import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  firmwares: [],
}

export const mutations = {
  setFirmwares(state, firmwares) {
    state.firmwares = firmwares
  },
}

export const actions = {
  async fetchFirmwares({ commit }) {
    const { data } = await ApiService.fetchFirmwares()
    const firmwares = data.data

    commit('setFirmwares', firmwares)
  },
}
